// 10 levels for the Tiger game.
// Each level has its own colour palette + procedural background settings.
// Music is described as a simple tonal pattern handled by audio.js.

export const LEVELS = [
  {
    id: 1,
    name: "Tropical Jungle",
    type: "jungle",
    emoji: "🌴",
    sky: ["#7ED7C1", "#3CAEA3"],
    ground: "#2D6A4F",
    groundDark: "#1B4332",
    accents: ["#45CB85", "#FFD166"],
    decor: "palm",
    music: { scale: [0, 2, 4, 7, 9], tempo: 110, instrument: "marimba" },
  },
  {
    id: 2,
    name: "Grasslands",
    type: "jungle",
    emoji: "🌾",
    sky: ["#FFE3A3", "#FFB870"],
    ground: "#C9A227",
    groundDark: "#8A6B17",
    accents: ["#E5C148", "#5A8F3D"],
    decor: "grass",
    music: { scale: [0, 2, 4, 5, 7], tempo: 100, instrument: "flute" },
  },
  {
    id: 3,
    name: "Mangrove",
    type: "jungle",
    emoji: "🌿",
    sky: ["#A8DADC", "#457B9D"],
    ground: "#3D5A40",
    groundDark: "#1B3A1E",
    accents: ["#7FB069", "#A0CFD8"],
    decor: "mangrove",
    music: { scale: [0, 3, 5, 7, 10], tempo: 95, instrument: "marimba" },
  },
  {
    id: 4,
    name: "Snowy Forest",
    type: "jungle",
    emoji: "❄️",
    sky: ["#CBE7F5", "#7FB6D6"],
    ground: "#F4F8FB",
    groundDark: "#A6BFD0",
    accents: ["#5C7A99", "#FFFFFF"],
    decor: "pine",
    music: { scale: [0, 2, 3, 7, 8], tempo: 88, instrument: "bells" },
  },
  {
    id: 5,
    name: "Deciduous Forest",
    type: "jungle",
    emoji: "🍂",
    sky: ["#FFD8A8", "#E89B5A"],
    ground: "#7C4D2A",
    groundDark: "#4F2E16",
    accents: ["#C45A2B", "#FFB347"],
    decor: "tree",
    music: { scale: [0, 2, 4, 7, 11], tempo: 105, instrument: "flute" },
  },
  {
    id: 6,
    name: "Home (City)",
    type: "city",
    emoji: "🏠",
    sky: ["#FFE5B4", "#FFAB76"],
    ground: "#9F8B6F",
    groundDark: "#6B5A45",
    accents: ["#FF6B6B", "#FFD93D"],
    decor: "house",
    music: { scale: [0, 4, 5, 7, 9], tempo: 115, instrument: "synth" },
  },
  {
    id: 7,
    name: "School (City)",
    type: "city",
    emoji: "🏫",
    sky: ["#B8E0FF", "#6BA8E5"],
    ground: "#8C6E54",
    groundDark: "#5A4632",
    accents: ["#E63946", "#F4A261"],
    decor: "school",
    music: { scale: [0, 2, 4, 7, 9], tempo: 120, instrument: "synth" },
  },
  {
    id: 8,
    name: "Mall (City)",
    type: "city",
    emoji: "🛍️",
    sky: ["#FFD6E0", "#FF8FA3"],
    ground: "#5A5A5A",
    groundDark: "#363636",
    accents: ["#F72585", "#7209B7"],
    decor: "mall",
    music: { scale: [0, 3, 5, 7, 10], tempo: 130, instrument: "synth" },
  },
  {
    id: 9,
    name: "Park (City)",
    type: "city",
    emoji: "🌳",
    sky: ["#C7F0BD", "#7FC97F"],
    ground: "#4F8A4D",
    groundDark: "#2E5C2E",
    accents: ["#FFB347", "#F8E16C"],
    decor: "park",
    music: { scale: [0, 2, 4, 5, 9], tempo: 108, instrument: "marimba" },
  },
  {
    id: 10,
    name: "Outer Space",
    type: "space",
    emoji: "🚀",
    sky: ["#0B0B2B", "#1A1A4F"],
    ground: "#3D3D6B",
    groundDark: "#1F1F3D",
    accents: ["#F8E16C", "#A06CD5"],
    decor: "stars",
    music: { scale: [0, 3, 7, 10, 12], tempo: 90, instrument: "bells" },
  },
];
